/* Buy bar for phones (snippets/rh-sticky-buy). Shows once the real add-to-cart button has been scrolled past (it is
   above the screen) and the footer is not in view, mirrors its label and price, and forwards the click. Hidden whenever the real button is disabled (sold,
   reserved, unavailable) and above phone width. */
(function () {
  var bar = document.querySelector('[data-rh-sbuy]');
  if (!bar) return;
  // A fixed bar inside the buy column would be positioned against that column (sticky/transformed ancestors), not
  // the screen; at the end of <body> it sits flush on the bottom edge.
  document.body.appendChild(bar);
  var section = bar.getAttribute('data-section');
  var real = document.getElementById('ProductSubmitButton-' + section);
  if (!real) return;
  var btn = bar.querySelector('[data-rh-sbuy-btn]');
  var price = bar.querySelector('[data-rh-sbuy-price]');
  var priceBox = document.getElementById('price-' + section);
  var footer = document.querySelector('footer, .footer');
  var phone = window.matchMedia('(max-width: 749px)');
  var realPassed = false;
  var footerInView = false;

  function blocked() {
    return real.disabled || real.getAttribute('aria-disabled') === 'true';
  }

  function sync() {
    var label = real.querySelector('span');
    if (label) btn.textContent = label.textContent.trim();
    var now = priceBox && priceBox.querySelector('.rh-pprice__now');
    if (now) price.textContent = now.textContent.trim();
  }

  function update() {
    var show = phone.matches && realPassed && !footerInView && !blocked();
    bar.hidden = !show;
    document.body.classList.toggle('rh-sbuy-on', show);
  }

  btn.addEventListener('click', function () {
    if (blocked()) return;
    real.click();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      realPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }).observe(real);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }
  }

  // The observer only reports changes of visibility; a jump from above the button to far below it (anchor link, fast
  // fling) keeps it "not visible" and would leave the bar off. A light scroll check catches that.
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var r = real.getBoundingClientRect();
      var passed = r.bottom < 0;
      if (passed !== realPassed) {
        realPassed = passed;
        update();
      }
    });
  }, { passive: true });

  // Variant changes re-render the price and the button label; the add-to-cart call toggles disabled while it runs.
  var watch = new MutationObserver(function () {
    sync();
    update();
  });
  watch.observe(real, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
  if (priceBox) watch.observe(priceBox, { childList: true, subtree: true, characterData: true });
  if (phone.addEventListener) phone.addEventListener('change', update);

  sync();
  update();
})();
